exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".letra {\r\n  font-size: 0.6em;\r\n  line-height: 1.0;\r\n  color:white;\r\n}\r\n\r\n.menu-user {\r\n  margin: 0;\r\n  min-width: 0;\r\n  padding: 30px;\r\n}\r\n\r\n.sidenav-menu-item {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  padding-left: 1em;\r\n  cursor: pointer;\r\n}\r\n\r\n.menu-item {\r\n  background-color: none;\r\n  transition: 0.5s;\r\n  color: white;  \r\n}\r\n\r\n.menu-item:hover {\r\n  background-color: white;\r\n  color: black;\r\n  cursor: pointer;\r\n}\r\n\r\ndiv.cdk-focus-trap-content{\r\n  overflow: hidden !important;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/github/490/rec_ng_recibopago490v7/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main